import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function PreviousYearQuestionsBioTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="biology" type="previousyearquestions" />

    </>
  );
}

export default PreviousYearQuestionsBioTopics;